import _ from 'lodash';
import 'firebase/auth';
import 'firebase/database';
// const withIds = allDevotees.map(devotee => ({ ...devotee, id: uuidv4() }));
// const first = [withIds[0]];
// withIds.shift();
// // console.log('all devotees', uuid, withIds);
// withIds.forEach(devotee => {
//   firestore.set({ collection: 'devotees', doc: devotee.id }, devotee);
// });
export const devoteeModel = {
  fullName: '',
  first: '',
  last: '',
  gmail: '',
  matrixEmail: '',
  congregation: {},
  transitions: [], // array of references to transition documents
  groupGender: '',
  group: {}, // reference
  groupList: [], //
  parish: {}, //reference to the primary parish
  parishList: [], //
  region: [], // reference
  roles: {
    superuser: false,
    admin: false,
    devotionalGroupLeader: false,
    user: true,
    parishLeader: false,
    devotee: true,
    educationLeader: false,
  },
  permissions: {
    read: false,
    edit: false,
    export: false,
  },
};

export const groupModel = {
  groupName: '',
  groupLeader: '', // reference
  label: '',
  id: '',
  type: '',
  members: [], // collection
  startDate: '',
  endDate: '',
};

// const updateDevGroups = async ({ firestore }) => {
//   const devotees = await firestore.collection('devotees').get();
//   const groups = await firestore.collection('devotionalGroups').get();
//
//   const groupNamesToIds = {};
//   groups.forEach(group => {
//     const data = group.data();
//     groupNamesToIds[data.groupName] = data.id;
//   });
//
//   const newDevotees = {};
//   devotees.forEach(devotee => {
//     const data = devotee.data();
//     newDevotees[data.id] = _.get(data, 'group.id');
//   });
//   // newDevotees['Testy Tester'] = 'testytesterid01';
//
//   const devoteeIdsByName = {};
//   devotees.forEach(devotee => {
//     const data = devotee.data();
//     devoteeIdsByName[data.fullName] = data.id;
//   });
//   console.log('devoteeIdsByName', devoteeIdsByName);
//
//   const newGroups = [];
//   groups.forEach(group => {
//     const data = group.data();
//     newGroups.push(data);
//   });
//
//   for (const group of newGroups) {
//     const newObject = _.merge({ ...groupModel }, group);
//     const groupId = group.id;
//     const devoteeListForGroup = Object.entries(newDevotees)
//       .filter(([key, value]) => groupId === value)
//       .map(([key, value]) => key);
//     const groupReference = await firestore.collection('devotionalGroups').doc(groupId);
//     const label = group.groupLeader;
//     // TODO: fix reference
//     const devoteeIdFrom = devoteeIdsByName[group.label];
//     console.log('group leader, dev id', devoteeIdFrom);
//     const leaderReference = devoteeIdFrom && await firestore.collection('devotees').doc(devoteeIdFrom);
//     newObject.label = label;
//     leaderReference && (newObject.leader = leaderReference);
//     console.log('leader reference', leaderReference, newObject);
//     // const update = await firestore.collection('devotionalGroups').doc(groupId).update(newObject);
//     // console.log('update', update);
//
//     const members = [];
//     for (const devoteeId of devoteeListForGroup) {
//       const devoteeReference = devoteeId && await firestore.collection('devotees').doc(devoteeId);
//       const member = {
//         startDate: '2019-06-01T00:00:00.000Z',
//         endDate: null,
//         devotee: devoteeReference,
//         isCurrent: true,
//       };
//       const devoteeRef = await devoteeReference.get();
//       const devoteeGroupLet = devoteeRef.data().group;
//       const devoteeGroupId = devoteeGroupLet && devoteeGroupLet.id;
//       console.log('devotees group id, devotee', devoteeGroupId);
//       const devoteeGroup = devoteeGroupId && await firestore.collection('devotionalGroups').doc(devoteeGroupId);
//
//       if (devoteeGroup && devoteeGroup.isEqual(groupReference)) {
//         console.log('is same reference');
//         members.push(member);
//       }
//     }
//     console.log('MEMBERS', members);
//     const updateMembers = await groupReference.update({
//       members
//     });
//     // console.log(updateMembers);
//   }
// };

async function updateDevotees({ firestore }) {
  const devotees = await firestore.collection('devotees').get();
  const groups = await firestore.collection('devotionalGroups').get();
  const groupNamesToIds = {};
  groups.forEach(group => {
    const data = group.data();
    groupNamesToIds[data.groupName] = data.id;
  });

  const newDevotees = [];
  devotees.forEach(devotee => {
    const data = devotee.data();
    newDevotees.push(data);
  });
  console.log('result of async collection get', newDevotees);
  for (const devotee of newDevotees.slice(10)) {
    const newObject = _.merge({ ...devoteeModel }, devotee);
    // create first and last names
    const names = newObject.fullName.split(' ');
    const first = names[0];
    const last = names[1];
    newObject.first = first;
    newObject.last = last || '';

    // convert isLeader to boolean
    const isLeader = newObject.isLeader === 'Yes' ? true : false;
    // delete newObject.isLeader;
    // update the role
    newObject.roles.devotionalGroupLeader = isLeader;

    // const person = await firestore.collection('devotees').doc(devotee.id);
    // const data1 = await person.get();
    // const data = data1.data();
    // let devoteeGroup = groupNamesToIds[data.groupName];
    // const group = devoteeGroup && await firestore.collection('groups').doc(devoteeGroup);
    // console.log(devoteeGroup);
    // const update = group && await person.update({
    //   group,
    // });
    // console.log('dev', groupNamesToIds);
    // const updatedDocument = _.merge(model, devotee.data());
  }
}

// create first and last names
// const names = updatedDocument.fullName.split(' ');
// const first = names[0];
// const last = names[1];
// updatedDocument.first = first;
// updatedDocument.last = last;
// // get the group reference
// let devoteeGroup = groupNamesToIds[updatedDocument.groupName];
// console.log('testing', devoteeGroup, updatedDocument);
// // updatedDocument.group = firestore.collection('groups').doc(devoteeGroup);
// // update the region
// // updatedDocument.region = firestore.collection('regions').doc(`0170701`);


// const person = await firestore.collection('devotees').doc(devotee.id);
// const data1 = await person.get();
// const data = data1.data();
// let devoteeGroup = groupNamesToIds[data.groupName];
// const group = devoteeGroup && await firestore.collection('groups').doc(devoteeGroup);
// console.log(devoteeGroup);
// const update = group && await person.update({
//   group,
// });


export const eventsModel = {
  type: '',  // education, devotionalGroup, parishMeeting, retreat, convocation
  description: '',
  label: '',
  startDate: {},
  endDate: {},
  isSingleDay: true,
  isRecurring: true,
  parentEvent: {}, // reference
  recurringPattern: {
    frequency: '', // weekly, daily, quarterly, annually
    pattern: '', // dayOfMonth, weekOfMonth, quarterOfYear, monthOfYear
    occursOn: '', // Monday, 1st, July
  },
  exceptions: {

  },
  attendances: {},
};

const attendancesModel = {
  attended: false,
  attendee: {}, // reference to devotee
  createdBy: {}, // reference to logged in user
  createdOn: {}, // timestamp
  delivery: '', // online|inPerson|
  event: {}, // event reference
  eventAgreement: {
    description: '',
    hasAgreement: false,
    onGoingAgreement: {}, // reference to agreement
  },
  group: {},
  id: '', // uuidv4
  location: {},
  notes: '',
  participation: '', // full|partial
};

export {
  updateDevotees,
  attendancesModel,
  // updateDevGroups,
};
